import { useState, useEffect } from 'react'
import { useSelector } from "react-redux"
import EligibilityStatus from './EligibilityStatus'
import AvailabilityDashboardStatus from './AvailabilityDashboardStatus'
import classes from './Dashboard.module.scss'
import PageHeading from './../../shared/PageHeading'
import Icon from '../../../Icon'
import { Link } from 'react-router-dom'
import useProfile from '../../../customHooks/useProfile'

import { useCrossPageAssessmentMethods } from '../useCrossPageAssessmentMethods'


const Dashboard = () => {
  const profileStatus: UserProfileStatus = useSelector((state: ProfileState) => state.profile)
  const [profileStatusData, setProfileStatusData] = useState<UserProfileStatus>(profileStatus)
  const { getUserProfileStatus, accountInfo } = useProfile()
  const user: IUser = useSelector((state: UserState) => state.user)
  const [error, setError] = useState('')

  const profileIsComplete = () => calculateProfileProgress(profileStatusData) === 1
  
  function calculateProfileProgress(profileData: UserProfileStatus){
    const entries = Object.entries(profileData).filter((kvp) => kvp[0] !== 'availabilityStatus' && kvp[0] !== 'profileStatus' && kvp[0] !== 'cyberAssessmentTakenOn' && kvp[0] !== 'cyberAssessmentMessage' && kvp[0] !== 'docReviewAssessments');
    const denominator = entries.length > 0 ? entries.length : 1;
    const numerator = entries.filter((kvp) => kvp[1] === true).length;
    return numerator / denominator;
  }
  
  
  const { getRequiredAssessments, getOtherAssessments } = useCrossPageAssessmentMethods()
  
  const getAssessmentStatus = (requiredAssessments: RequiredAssessmentProps[], optionalAssessments: OtherAssessmentProps[]) => {
    let requiredAssessmentsByLanguage = requiredAssessments.flatMap(assessment => assessment.languages);
    
    let trulyRequiredLanguages = requiredAssessmentsByLanguage.filter(language => language.required);
    let trulyRequiredCompleted = trulyRequiredLanguages.filter(language => language.takenAt !== null).length;
    let trulyRequiredPossible = trulyRequiredLanguages.length;
    
    let optionalLanguagesOfRequiredAssessments = requiredAssessmentsByLanguage.filter(language => !language.required);
    let optionalOfRequiredCompleted = optionalLanguagesOfRequiredAssessments.filter(language => language.takenAt !== null).length;
    let optionalOfRequiredPossible = optionalLanguagesOfRequiredAssessments.length;
    
    let trulyOptionalLanguages = optionalAssessments.flatMap(assessment => assessment.languages);
    let trulyOptionalCompleted = trulyOptionalLanguages.filter(language => language.takenAt !== null).length;
    let trulyOptionalPossible = trulyOptionalLanguages.length;
    
    let requiredCompleted = trulyRequiredCompleted;
    let requiredPossible = trulyRequiredPossible;
    let optionalCompleted = trulyOptionalCompleted + optionalOfRequiredCompleted;
    let optionalPossible = trulyOptionalPossible + optionalOfRequiredPossible;
    
    return {
      requiredCompleted,
      requiredPossible,
      optionalCompleted,
      optionalPossible
    };
  }
  
  const isEligible = () => {
    if (!profileIsComplete()) return false;
    const { requiredCompleted, requiredPossible } = getAssessmentStatus(getRequiredAssessments(), getOtherAssessments())
    return requiredCompleted === requiredPossible
  }
  
  useEffect(() => getUserProfileStatus(setProfileStatusData), [user])
  useEffect(() => console.log(error), [error])
  
  return (
    <div>
      <div>
        <div className={classes.account_button}>
          <Link className="btn" to='/account'>
            <Icon name='gear' size='36' />
          </Link>
        </div>
        <PageHeading
          title='Dashboard'
          description='Manage your account, update your profile details including licensure, education, and experience. Head to the assessment area to show off your document review skills.'
          divider
        />
      </div>
      <EligibilityStatus status={isEligible()} profileProgress={calculateProfileProgress(profileStatusData)} assessmentStatus={getAssessmentStatus(getRequiredAssessments(), getOtherAssessments())} />
      <AvailabilityDashboardStatus availability={profileStatusData.availabilityStatus ?? false} tempUserDontKeep={{firstName: user.firstName, lastName: user.lastName, email: user.email}} updateAccount={accountInfo} setError={setError} isEligible={isEligible()} />
    </div>
  )
}

export default Dashboard
